import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskHandler, TaskHandler } from "./taskHandler";

export interface ITaskEditItem extends IEditItem {
    companyId: string;
    taskTypeId: string;
    taskStateId: string;
    taskPriorityId: string;
    unitId: string;
    code: string;
    name: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    deleteUser: IModifyUser;
    archiveUser: IModifyUser;
    lockedUser: IModifyUser;
    taskHeaderDataCols: ITaskDataRowCol[];
    taskDataRows: ITaskDataRow[];
    handlers: ITaskHandler[];

    initializeDataRowsRows(taskType: ITaskEditTypeItem);
    isLockedToOtherUser(userCode: string): boolean;
}

export class TaskEditItem extends EditItem implements ITaskEditItem {
    companyId: string;
    taskTypeId: string;
    taskStateId: string;
    taskPriorityId: string;
    unitId: string;
    code: string;
    name: string;
    isRead: boolean;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    deleteUser: ModifyUser;
    archiveUser: IModifyUser;
    lockedUser: ModifyUser;
    taskHeaderDataCols: TaskDataRowCol[];
    taskDataRows: TaskDataRow[];
    handlers: TaskHandler[];

    constructor();
    constructor(obj: ITaskEditItem);
    constructor(obj?: any) {
        super(obj);
        this.companyId = obj && obj.companyId || "";
        this.taskTypeId = obj && obj.taskTypeId || "";
        this.taskStateId = obj && obj.taskStateId || "";
        this.taskPriorityId = obj && obj.taskPriorityId || "";
        this.unitId = obj && obj.unitId || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.isRead = obj && obj.isRead || "";
        this.createUser = new ModifyUser(obj?.createUser);
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.deleteUser = obj?.deleteUser ? new ModifyUser(obj.deleteUser) : null;
        this.archiveUser = obj?.archiveUser ? new ModifyUser(obj.archiveUser) : null;
        this.lockedUser = obj?.lockedUser ? new ModifyUser(obj.lockedUser) : null;
        this.taskHeaderDataCols = Base.getTypedArray(obj?.taskHeaderDataCols, TaskDataRowCol);
        this.taskDataRows = Base.getTypedArray(obj?.taskDataRows, TaskDataRow);
        this.handlers = Base.getTypedArray(obj?.handlers, TaskHandler);
    }

    initializeDataRowsRows(taskType: ITaskEditTypeItem) {
        this.taskHeaderDataCols = TaskDataRowCol.initializeValuesByType(taskType.headerCols, this.taskHeaderDataCols);
        for (const taskDataRow of this.taskDataRows) {
            taskDataRow.initializeCols(taskType);
        }
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}